import "./polyfill";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import {
    getClientErrorRootOptions,
    installClientErrorReporting,
} from "@/utilities/client-error-reporting";
import App from "./App";
import "./index.css";

installClientErrorReporting("resume-builder");

createRoot(
    document.getElementById("root"),
    getClientErrorRootOptions("resume-builder"),
).render(
    <StrictMode>
        <App />
    </StrictMode>,
);
